import { InjectionToken } from '@angular/core';
import { AssetVersionDto } from '@picflow/types';
import { Observable } from 'rxjs';

export interface VirusScan {
  onScanned(asset: AssetVersionDto): Observable<AssetVersionDto>;
}

export const VIRUS_SCAN = new InjectionToken<VirusScan>('VirusScan');
